import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
	selector: 'app-checkbox',
	template: `
<div class="full-width-field" [formGroup]="group" >
<mat-checkbox [formControlName]="field.name" id="id_number">{{field.label}}</mat-checkbox>
</div>
`,
	styles: []
})
export class CheckboxComponent implements OnInit {
	field: FieldConfig;
	group: FormGroup;
	constructor() {}
	ngOnInit() {}
}
